import Model from './Model'
import { formatBytes } from '@/utils/format.util'

const getType = (name) => {
  if (name.includes('/')) {
    return 'folder'
  }

  const arr = name.split('.')
  const type = arr[arr.length - 1]

  return type
}

export default class S3Object extends Model {

  get attributes () {
    return [
      'ETag',
      'changedAt',
      'name',
      'key',
      'size',
      'type',
      'versionId',
      'lastModified',
      'isLatest',
      'isDeleted'
    ]
  }

  constructor (data) {
    super(data)

    this.changedAt = data.LastModified && data.LastModified.toLocaleString('ru')
    this.checked = false
    this.key = data.Key
    this.size = data.Size ? formatBytes(data.Size) : null
    this.type = data.type ? data.type : getType(data.name)
  }

  set checked (state) {
    state = !!state
    this.__checked = state
    this.checkedTime = state ? Date.now() : 0
  }

  get checked () {
    return this.__checked
  }
}
